const replaceDotsWithUnderscores = (str: string) => {
  return str?.replace(/\./g, '_') || '';
}

export default replaceDotsWithUnderscores;